// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../engines/components/BaseComponent";
import O1HD from "../../../engines/gameEngine";
import utilsModel from "../../../engines/libs/utilsModel";
import getOneBundle, { BUNDLE_SMALL_NAME } from "../../../modes/normalMode/BundleResourceConfig";
import { backPackEventMap } from "../../../modes/normalMode/config/BackpackEventConfig";
import NormalGameManager from "../../../modes/normalMode/manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

const c_gold_price = 2000000000;
const c_max_ad = 3;
@ccclass
export default class PawnRansomGoodsItem extends BaseComponent {

	@property({ type: cc.Label, displayName:'' })
	labelAdCont: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelName: cc.Label = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprGoods: cc.Sprite = null;

    private goodsId = 0;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.initUI();
    }

    setData(id: number) {
        this.goodsId = id;
    }

    initUI() {
        this.refreshAdCount();

        this.showGoods();
    }

    async showGoods() {
        let goodsId = this.goodsId;
        let goodsConfig = backPackEventMap()[goodsId];
        let spPath = goodsConfig.spPath;
        let sprGoods = this.sprGoods;
        let gwidth = sprGoods.node.width * sprGoods.node.scaleX;
        let gheight = sprGoods.node.height * sprGoods.node.scaleY;

        this.labelName.string = goodsConfig.name;
        sprGoods.node.active = false;
        let iconPath = "backpackAssets/objSp/" + spPath;
        let bundle = await getOneBundle( BUNDLE_SMALL_NAME.backPackGameBundle );
        bundle.load(iconPath, cc.SpriteFrame
            , (err,imgs:cc.SpriteFrame)=>
            {
                if(err){
                    console.log(err);
                }else{
                    sprGoods.node.active = true;
                    sprGoods.spriteFrame = imgs;

                    let scale = Math.min(gwidth / sprGoods.node.width, gheight / sprGoods.node.height);
                    sprGoods.node.scale = scale;    
                }
            }
        );
    }

    refreshAdCount() {
        let gameData = NormalGameManager._instance.getGameData();
        let count = gameData.pawnRansomAdCount[this.goodsId] || 0;
        this.labelAdCont.string = `(${count}/${c_max_ad})`;
    }

    onClickGoldBuy() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        let price = c_gold_price;
        if ( O1HD.getServices().userSrv.getCoins() < price) {
            O1HD.getModules().uiControlModule.showMessageBox("金额不足",this.node);
            NormalGameManager._instance.openBankPage();
            return;
        }
        O1HD.getServices().userSrv.setCoins( -price, true);
        O1HD.getModules().uiControlModule.showMessageBox("赎回成功");
        this.recvSuccess();
    }

    onClickAdBuy() {
        O1HD.getManagers().soundMgr.playSound("anNiu");

        let gameData = NormalGameManager._instance.getGameData();
        let count = gameData.pawnRansomAdCount[this.goodsId] || 0;
        utilsModel.loadAndShowVideoAdTrans(()=>{
            count++;
            if (count >= c_max_ad) {
                O1HD.getModules().uiControlModule.showMessageBox("领取成功");
                this.recvSuccess();
                count = 0;
            }
            gameData.pawnRansomAdCount[this.goodsId] = count;
            NormalGameManager._instance.writeGameData();
            this.refreshAdCount();
        },()=>{

        },null,"观看广告赎回装备");
    }

    recvSuccess() {
        utilsModel.onPushGoods(this.goodsId, 1);
    }

    // update (dt) {}
}
